export default "__VITE_ASSET__CYW3Yslh__"